//Utilities for Date and time

import moment from "moment";
import { DateTime, Duration } from "luxon";

//Returns remaining time given an end time
//Format is [WEEK] week(s) [DAY] day(s) [HOUR] hour(s) [MINUTES] minute(s)
//From: https://stackoverflow.com/a/49385955
export const getDurationStr = (end: Date): string => {
  //Get initial difference between end and now
  const duration = moment.duration(moment(end).diff(moment()));

  //Get the weeks difference
  const timeRemainingWeeks = Math.floor(duration.asWeeks());
  //Subtract the weeks from our calculated duration
  duration.subtract(moment.duration(timeRemainingWeeks, "weeks"));
  const timeRemainingDays = Math.floor(duration.asDays());
  duration.subtract(moment.duration(timeRemainingDays, "days"));
  const timeRemainingHours = Math.floor(duration.asHours());
  duration.subtract(moment.duration(timeRemainingHours, "hours"));
  const timeRemainingMins = Math.floor(duration.asMinutes());
  duration.subtract(moment.duration(timeRemainingMins, "minutes"));

  const timeRemaining = `${timeRemainingWeeks} week(s) ${timeRemainingDays} day(s) ${timeRemainingHours} hour(s) ${timeRemainingMins} minute(s)`;

  return timeRemaining;
};

export const getDuration = (end: Date): number => {
  const duration = moment.duration(moment(end).diff(moment()));

  return duration.asMilliseconds();
};

//Returns percentage of time elapse from start to end
export const getDurationRemaining = (start: Date, end: Date): number => {
  const totalDuration = moment.duration(moment(end).diff(start));
  const elapseDuration = moment.duration(moment(end).diff(moment()));

  return (
    100 -
    (elapseDuration.asMilliseconds() / totalDuration.asMilliseconds()) * 100
  );
};

//Converts Date time string to unix seconds
export const toUnixSeconds = (datetime: string): number => {
  try {
    return DateTime.fromISO(datetime).toSeconds();
  } catch (error) {
    return -1;
  }
};

//Parses unix seconds to datetime-local format
export const parseUnixSeconds = (seconds: number): string => {
  try {
    return DateTime.fromSeconds(seconds).toFormat("yyyy-MM-dd'T'HH:mm");
  } catch (error) {
    return "";
  }
};

//Parses unix seconds to datetime format
export const parseUnixSecondsToDate = (seconds: number): string => {
  try {
    return DateTime.fromSeconds(seconds).toFormat("yyyy-MM-dd");
  } catch (error) {
    return "";
  }
};

//Gets duration and return as a single unit (eg: days, hours, or minutes)
export const getDurationAsUnit = (unixEpochSeconds: number) => {
  if (unixEpochSeconds >= 86400) {
    // Days
    return `${Duration.fromMillis(unixEpochSeconds * 1000).as("days")} days`;
  } else if (unixEpochSeconds >= 3600) {
    // Hours
    return `${Duration.fromMillis(unixEpochSeconds * 1000).as("hours")} hours`;
  } else {
    // Minutes
    return `${Duration.fromMillis(unixEpochSeconds * 1000).as(
      "minutes"
    )} minutes`;
  }
};
